export const analytics = {
  triggerAnalytics: () => {
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('store-pod.select-store', {});
    }
  }
};
